<template>
    <el-container style="flex-flow: row">
        <section-list :sectionList="sectionList" @handleSelect="handleSelect" ref="sectionList" v-if="!searchVal"></section-list>
        <el-main v-loading="loading">
            <el-collapse accordion v-if="helpList.length > 0" v-model="activeName">
                <el-collapse-item :title="(index + 1) + '、'+ item.title" :name="item.id" v-for="(item, index) in helpList" :key="item.id">
                    <div class="ql-snow">
                        <div class="ql-editor" v-html="item.content"></div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <!--缺省-->
            <div v-if="helpList.length === 0" style="text-align: center;margin-top: 50px">
                <img src="@/assets/img/none.png" alt="" width="240" height="240">
            </div>
        </el-main>
    </el-container>
</template>

<script>
    const SectionList = () => import('@/components/section/SectionList');
    export default {
        name: "Help",
        components: {
            SectionList
        },
        data() {
            return {
                activeName: '',
                sectionList: [],
                helpList: [],
                currentSectionId: '',
                searchVal: '',
                loading: false
            }
        },
        methods: {
            async getSectionAndHelpList() {
                this.searchVal = this.queryTitle = this.$route.query.title;
                if (!this.searchVal) {
                    const { content } = await this.$http.get('/system/web/code/getByCodeType', { params: { codeType: 'HELP_CENTER' } });
                    if (content) {
                        this.sectionList = content;
                        const codeNum = this.sectionList[0].codeNum;
                        this.currentSectionId = codeNum;
                        setTimeout(() => {
                            this.$refs.sectionList.defaultChoose = codeNum;
                        }, 100);
                    }
                }
                this.getHelpList();
            },
            async getHelpList() {
                this.loading = true;
                const params = {
                    sectionId: this.currentSectionId,
                    title: this.searchVal,
                };
                const { content } = await this.$http.post('/business/web/help/list', params);
                this.helpList = content;
                this.loading = false;
            },
            handleSelect(index, indexPath) {
                this.currentSectionId = index;
                this.getHelpList();
            },
        },
        mounted() {
            this.getSectionAndHelpList();
            if (this.$route.query.id){
                this.activeName = this.$route.query.id;
            }
        },
        watch: {
            // 监听页头传搜索值
            $route: function () {
                this.getSectionAndHelpList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-container {
        width: 1000px;
        margin: 35px auto 0 auto;
    }

    .el-header {
        height: 40px !important;
    }

    .el-main {
        margin: 0 0 50px 15px;
        padding: 12px 30px;
        min-height: 545px;
        border: 1px solid #EBEEF5;
        border-radius: 6px;
        box-shadow: 0 1px 7px rgba(0, 0, 0, .12);;
    }

    .help-title {
        font-size: 18px;
        font-weight: bold;
        margin-left: 10px;
    }

    i {
        margin-right: 5px;
    }

     /deep/ .el-collapse-item__header  {
        font-size: 16px;
        &:hover {
            color: #409EFF;
        }
    }

    /deep/ .el-collapse-item__header.is-active  {
        color: #409EFF;
    }

</style>
